export function StateTable(data, initSearch){
	initSearch = initSearch || '';
	// console.log(data);
	//$("#result").append("<table class='table-condensed table table-hover' id='stb' border='1'cellspacing='0' bordercolor='#cccccc'></table>");
	var $history = $("#history");
	$history.bootstrapTable("destroy");
	$history.bootstrapTable(
		{
		//method: 'get',		
		data:data,
		//detailView: true,
		//pagination: true,
		//pageSize: 10,
		//pageList: [10,25,50,100],
		search: true,
		searchText: initSearch,
		responseHandler: function (res) {
			if (Array.isArray(res)) {
				return res.reverse();
			}
			return res;
		},
		columns:[
			{
				field:'Jobid',
				title:'Job ID',
				align: 'center',
				valign: 'middle'
			},
			{
				field:'Status',
				title:'Status',
				align: 'center',
				valign: 'middle'
			},
			{
				field:'Time Used',
				title:'Time used',
				align: 'center',
				valign: 'middle'
			},
			{
				field:'Result',
				title:'Result',
				align: 'center',
				valign: 'middle',				
			},
		]
	});	
	//$("#stb").bootstrapTable('append',data);
}